module.exports = __webpack_public_path__ + "static/media/result_fr_ja.51a4c750.jpg";